/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Inject } from '@angular/core';
import { NonNullableFormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { catchError, EMPTY, finalize, tap } from 'rxjs';
import { PostService } from '../../../../services/api/post/post.service';
import { CreatePostEventService } from '../../../../services/helper/create-post-event/create-post-event.service';
import { LoaderService } from '../../../../services/loader/loader.service';
import { BasePopupComponent } from '../base-popup/base-popup.component';
import { SuccessPopupComponent } from '../success-popup/success-popup.component';

@Component({
    selector: 'app-testimony-popup',
    standalone: false,
    templateUrl: './testimony-popup.component.html',
    styleUrl: './testimony-popup.component.scss',
})
export class TestimonyPopupComponent extends BasePopupComponent {
    protected testimonyForm = this.fb.group({
        testimony: ['', Validators.required],
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) protected override data: any,
        protected override dialogRef: MatDialogRef<TestimonyPopupComponent>,
        private fb: NonNullableFormBuilder,
        private loaderService: LoaderService,
        private postService: PostService,
        private createPostEventService: CreatePostEventService,
        private dialog: MatDialog,
    ) {
        super(data, dialogRef);
    }

    protected submit(): void {
        if (this.testimonyForm.invalid) {
            this.testimonyForm.markAllAsTouched();
            return;
        }

        const payload = this.testimonyForm.controls.testimony.value;
        this.postService
            .markPostAnswered(this.data.postId, payload)
            .pipe(
                tap(() => {
                    const popupConfig = SuccessPopupComponent.getDialogConfig();
                    popupConfig.data = {
                        title: 'Testimony Shared!',
                        message: 'You have marked this as answered. Your testimony is now visible to encourage others.',
                        iconPath: '/assets/images/shared/success-green-icon.svg',
                        confirmButtonLabel: 'Amen',
                    };
                    // Success popup
                    this.dialog.open(SuccessPopupComponent, popupConfig);
                    this.dialogRef.close(true);
                    this.createPostEventService.notifyPostAnswered();
                }),
                catchError((error) => {
                    const errorPopupConfig = SuccessPopupComponent.getDialogConfig();
                    errorPopupConfig.data = {
                        title: `Error`,
                        message: error.error?.message,
                    };
                    this.dialog.open(SuccessPopupComponent, errorPopupConfig);
                    console.error('Error creating testimony:', error);
                    return EMPTY;
                }),
                finalize(() => this.loaderService.hide()),
            )
            .subscribe();
    }
}
